import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { polyfillLocalization } from 'i18n/locale';

import App from 'containers/App';
import LabelProvider from 'containers/LabelProvider';
import { launchdarkly } from '@ddc-webplatform/cmsc-modules';

import { APP_ROOT } from 'helpers/app';

import { LD_CLIENT_ID } from './constants/composer';

const renderRoot = async () => {
	if (APP_ROOT) {
		const LDProvider = await launchdarkly.asyncComposerLDProvider(LD_CLIENT_ID);
		const root = createRoot(APP_ROOT);

		/* this logic is to handle removing injected stylesheets */
		APP_ROOT.addEventListener('unmount-react-app', () => {
			root.unmount()
		});

		// renders app
		root.render(
			<LDProvider>
				<LabelProvider>
					<App />
				</LabelProvider>
			</LDProvider>
		);
	}
};

polyfillLocalization.then(renderRoot);
